import React, { FC } from 'react';
import { DropdownOptionInterface, Select } from '@beef/ui-kit';
import classNames from 'classnames/bind';
import { emptyObj } from '@beef/utils';

import Dots from './dots.svg';
import { IdType, MenuType } from '../../types';
import styles from './styles.pcss';

const cn = classNames.bind(styles);

export const Menu: FC<MenuType> = ({ menuOptions, onChange, onClick }) => {
  if (!menuOptions?.length) return null;

  //  хендлер по клику на пункт из меню- передаем label меню
  const onChangeHandler = (id: IdType) => {
    if (!onChange) return;
    const { type, label } =
      menuOptions.find((option) => option.id === id) || (emptyObj as DropdownOptionInterface);
    onChange({ id, type, label });
  };

  return (
    <div className={cn('menu')}>
      <Select
        icon={
          <div className={cn('icon')}>
            <Dots />
          </div>
        }
        onChange={onChangeHandler}
        onFocus={onClick}
        options={menuOptions}
        theme="secondary"
        value=""
      />
    </div>
  );
};
